import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import HelpArticleLink from '../../../../../components/help-article-link';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import styles from './styles.module.less';

export const DocSection = ({ childrenBeforeDoc = null, descriptionMessage, articleId, childrenAfterDoc = null }) => {
  return (
    <section className={styles['doc-section']}>
      {childrenBeforeDoc}
      <div className={styles['doc-section-information']}>
        <FontAwesomeIcon className={styles['doc-section-icon']} icon={faInfoCircle} />
        <span className={styles['doc-section-description']}>
          <FormattedMessage
            {...descriptionMessage}
            values={{
              a: (chunks) => <HelpArticleLink articleId={articleId}>{chunks}</HelpArticleLink>,
            }}
          />
          {childrenAfterDoc}
        </span>
      </div>
    </section>
  );
};

DocSection.propTypes = {
  articleId: PropTypes.string.isRequired,
  childrenBeforeDoc: PropTypes.any,
  descriptionMessage: MessageDescriptorPropType.isRequired,
  childrenAfterDoc: PropTypes.any,
};
